'use client';

import { ArrowLongUpIcon } from '@heroicons/react/20/solid';
import { useEffect, useState } from 'react';

import { useIsTattooPage } from '@/hooks/useIsTattooPage';
import { cn } from '@/lib/utils';

type Props = {
  className?: string;
};

const ScrollTopButton = ({ className = '' }: Props) => {
  const isTattooPage = useIsTattooPage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const windowHeight = window.innerHeight;
    const handleScroll = () => {
      const scrollTop = window.scrollY || window.pageYOffset;
      setIsVisible(scrollTop > windowHeight);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={cn(
        'focus:ring-opacity-50 fixed right-4 bottom-4 rounded-full p-3 text-white transition-all focus:ring-2 focus:outline-none',
        isVisible ? 'opacity-60' : 'pointer-events-none opacity-0',
        isTattooPage
          ? 'bg-emerald-500 hover:bg-emerald-600 focus:ring-emerald-600'
          : 'bg-amber-500 hover:bg-amber-600 focus:ring-amber-600',
        className,
      )}
    >
      <ArrowLongUpIcon className="h-5 w-5" />
    </button>
  );
};

export default ScrollTopButton;
